import React from 'react';
import IconComponent from "../../reusable/simpleComponents/IconComponent";

interface Props {
    classValue: string,
    onClick: (e: React.MouseEvent) => void
    title: string
}

const PTZIconComponent: React.FC<Props> = ({ classValue, onClick, title }) => {
    return (
        <div className='icon-background ptzIcon pointer'>
            <IconComponent classValue={classValue}
                           handler={onClick}
                           title={title}
            />
        </div>
    );
};


export default PTZIconComponent;